const caseList = () => import("@/pages/case/list/index.vue");
const caseListForm = () => import("@/pages/case/list/form.vue");
const caseListDetail = () => import("@/pages/case/list/detail.vue");

export default [
    {
        path: "/case/list",
        component: caseList,
        meta: [
            {
                name: "案例管理",
                activeRoute: "/case/manage",
            },
            {
                name: "案例列表",
                activeRoute: "/case/list",
            },
        ],
    },
    {
        path: "/case/list/form",
        component: caseListForm,
        meta: [
            {
                name: "案例管理",
                activeRoute: "/case/manage",
            },
            {
                name: "案例列表",
                url: "/case/list",
            },
            {
                name: "新增/编辑",
                activeRoute: "/case/list",
            },
        ],
    },
    {
        path: "/case/list/detail",
        component: caseListDetail,
        meta: [
            {
                name: "案例管理",
                activeRoute: "/case/manage",
            },
            {
                name: "案例列表",
                url: "/case/list",
            },
            {
                name: "案例详情",
                activeRoute: "/case/list",
            },
        ],
    },
];
